<!-- ======= Header ======= -->
<!-- before login header -->
<div class="fixed-top" *ngIf="!_common.getToken()">
  <div class="loginheader" >
    <div class="container-fluid" >
      <div class="row">
        <div class="col-xl-12 col-12 logob2c">
          <div class="logo">
            <a href="javascript:void(0);" class="b2clogolink" routerLink="/home">
              <img src="assets/img/{{env.host.name}}/logo.png"  alt="logo" class="loginlogo">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
<!-- before login header -->

<!-- after login header -->
<app-topnav [freeplayHomePage]="true"></app-topnav>
<!-- after login header -->



<div class="help_div container">
<h1>একাউন্ট</h1> <br />

<h3>১৮+ নীতি</h3>
Freeplay24-তে রেজিস্ট্রেশন করতে বা বেট রাখতে সমস্ত আবেদনকারীদের ১৮ বছর বা তার বেশি বয়সী হতে হবে। Freeplay24 কোন সদস্যের কাছ থেকে বয়স প্রমাণের সন্তোষজনক নথিপত্র সরবরাহের অনুরোধ করার অধিকার, সরবরাহ না করা বা সঠিক প্রমাণ হওয়া পর্যন্ত তাদের অ্যাকাউন্ট সকল কার্যক্রম স্থগিত করার অধিকার সংরক্ষণ করে। অপ্রাপ্তবয়স্কদের এবং দায়িত্বশীল গেম্বেলিং এর জন্য আমাদের দায়িত্ব গুলো আমরা খুব গুরুত্ব সহকারে নিই। <br />

উপরে বর্ণিত সুরক্ষা পদ্ধতি ছাড়াও, পিতামাতারা অপ্রাপ্তবয়স্কদের ই-গেমিং ওয়েবসাইটে অ্যাক্সেস করা থেকে বাঁচাতে বাছাই করা মানদণ্ডের ভিত্তিতে ফিল্টারিং সমাধান গুলোর সাথে ইন্টারনেট অ্যাক্সেস নিয়ন্ত্রণ করতে পারেন।আমরা বিশ্বাস করি যে এই ধরনের প্রতিরোধমূলক ব্যবস্থা গুলো আমাদের এবং অপ্রাপ্তবয়স্ক অভিভাবকদের মধ্যে একটি যৌথ দায়িত্ব হিসাবে সবচেয়ে কার্যকর<br />

আপনি যদি জানেন যে অপ্রাপ্ত বয়স্ক কেউ Freeplay24-র সাথে নিবন্ধিত রয়েছে, দয়া করে 24/7 গ্রাহক সেবা লাইনে আমাদের সাথে যোগাযোগ করুন এবং আমরা প্রয়োজনীয় পদক্ষেপ নেব।<br />
নোট : যদি অপ্রাপ্তবয়স্ক কেউ Freeplay24-র সাথে গেম্বেলিং করতে দেখা যায় তবে সমস্ত উইনিং বাজেয়াপ্ত করার অধিকার Baji সংরক্ষণ করে।<br />

আমি কিভাবে Freeplay24 -তে সাইন আপ করব?<br />

Freeplay24-তে সাইন আপ করা খুবই সহজ ! নিম্মে ৩টি সহজ কাজ :<br /> 

ধাপ ১: Freeplay24 হোমপেজে যান এবং হোমপেজ থেকে ‘সাইন আপ’ বাটন ক্লিক করুন।<br />
ধাপ ২: আপনার ব্যক্তিগত তথ্য দিয়ে রেজিস্ট্রেশন করুন। আমাদের যা প্রয়োজন: <br />
ক. আপনার ফোন নম্বর <br />
খ. পাসওয়ার্ড <br />
পাসওয়ার্ড বিষয়টি সেনসিটিভ, এতে যা যা থাকা উচিত:<br /><br />

<h4>৬-২০ টি অক্ষর</h4>
ন্যূনতম ১টি বড় হাতের অক্ষর (A-Z)<br />
ন্যূনতম ১টি ছোট হাতের অক্ষর (a-z)<br />
ন্যূনতম ১টি সংখ্যা (০-৯) <br />
স্পেশাল অক্ষর গ্রহণযোগ্য (@$!%*#) <br /><br />

<img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/picture1.png" alt=""><br /><br />


<h4>পাসওয়ার্ড গাইডলাইন</h4>
পাসওয়ার্ড বিষয়টি সেনসিটিভ, এতে যা যা থাকা উচিত:<br />
৬-২০ টি অক্ষর<br />
ন্যূনতম ১টি বড় হাতের অক্ষর (A-Z) <br />
ন্যূনতম ১টি ছোট হাতের অক্ষর (a-z) <br />
ন্যূনতম ১টি সংখ্যা (০-৯) <br />
স্পেশাল অক্ষর গ্রহণযোগ্য (@$!%*#)<br /><br />

আমি আমার পাসওয়ার্ড ভুলে গেলে আমার কী করা উচিত?<br />
<img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/picture2.png" alt=""><br /><br />

                 
ধাপ ১: Freeplay24 হোমপেজে ‘লগইন’ বাটনে ক্লিক করুন এবং ‘ফরগট পাসওয়ার্ড ” এ ক্লিক করুন।<br />

ধাপ ২: ফরগেট পাসওয়ার্ড করলে আপনি আপনার নম্বর বসানোরর জায়গা পাবেন ওখানে নম্বর দিলেই আপনার নম্বর এ OTP যাবে যেটা দিয়ে আপনি পাসওয়ার্ড রিসেট করেত পারবেন। <br /><br />
<img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/picture3.png" alt=""><br /><br />

<h4>কীভাবে কাস্টমার সাপোর্ট টিমের সাথে যোগাযোগ করবেন?</h4>
<h4>আমাদের ২৪/৭ কাস্টমার সাপোর্ট টিমের সাথে যোগাযোগ করতে,</h4>
<ul>
  <li>ধাপ ১: নীচে ডানদিকে অবস্থিত চ্যাট আইকনে ক্লিক করুন, বা উপরের বাম কোণে ড্রপ-ডাউন মেনু খুলুন।</li>
  <li>ধাপ ২: ’24/7 LiveChat’ বাটনটি সিলেক্ট করুন। </li>
  <li>ধাপ ৩: ‘Send us a message’ সিলেক্ট করুন। </li>
  <li>ধাপ ৪: আপনার পছন্দের ভাষা নির্বাচন করুন।</li>
  <li>ধাপ ৫: আপনার জিজ্ঞাসিত প্রশ্নের দ্রুত সমাধানের জন্য আপনার প্রশ্ন নির্বাচন করুন বা আপনার আরও সহায়তার প্রয়োজন হলে “Chat with Us” এ ক্লিক করুন, আমাদের কাস্টমার সাপোর্ট প্রতিনিধি শীঘ্রই আপনার সাথে যোগাযোগ করবে৷ </li>
  <li>ধাপ ৬: আপনার যদি আমাদের সাথে একটি অ্যাকাউন্ট থাকে তবে আপনার তথ্য প্রদান করুন।</li>
</ul><br /><br />

<h3>পেমেন্ট</h3>


Feeplay24-তে কোন ধরণের ডিপোজিট পদ্ধতি এভেইল্যাবল?<br />
নীচের পদ্ধতিগুলি ব্যবহার করে আমাদের সাইটে ডিপোজিট করা যায়। আপনার পক্ষে সবচেয়ে সুবিধাজনক পেমেন্ট অপশনটি সিলেক্ট করতে সহায়তা পেতে এই তথ্যসমুহ ব্যবহার করুন। <br /><br />
নগদ <br />
বিকাশ <br />
রকেট <br /><br />


সদস্যদের জন্য সর্বনিম্ন ডিপোজিটের পরিমাণ হল ৫০০ টাকা <br />
সর্বোচ্চ ডিপোজিট হচ্ছে ২৫০০০ টাকা <br />
প্রতিদিন ডিপোজিট / উইথড্রয়াল ট্রানজেকশন কতবার করা যাবে তার কি কোনও লিমিট রয়েছে?<br />
আপনি প্রতিদিন কতবার ডিপোজিট / উইথড্রয়াল ট্রানজেকশন করতে পারবেন তার কোনও লিমিটেশন নেই।<br />
সাপ্তাহিক ছুটির দিনগুলোতে আমার ডিপোজিট / উইথড্রয়াল জমা দেওয়া যাবে?<br />
হ্যাঁ, আমাদের ডিপোজিট সার্ভিস অপারেশনের 24/7, এবং উইথড্রয়াল সার্ভিস অপারেশনের সময় 24/7 <br /><br />

<h3>কীভাবে উইথড্রয়াল করবেন?</h3>

ধাপ ১:<br />
“উইথড্র” সিলেক্ট করুন।<br />
ধাপ ২:<br />
আপনার পছন্দের পেমেন্ট চ্যানেল সিলেক্ট করুন। বর্তমানে আমরা বিকাশ, নগদ, রকেট এবং লোকাল ব্যাংকের উইথড্রয়াল চ্যানেলগুলিকে সমর্থন করি।<br />
অনুগ্রহপূর্বক নোট করুন যে বিভিন্ন পেমেন্ট চ্যানেলগুলির ভিন্ন ভিন্ন ন্যূনতম এবং সর্বাধিক উইথড্রয়াল এমাউন্ট থাকবে।<br />
ধাপ ৩:<br />
“উইথড্র” বাটনে ক্লিক করুন এবং আপনি একটি নোটিফিকেশন পাবেন যে আপনার উইথড্রয়াল গ্রহণ করা হয়েছে এবং প্রক্রিয়াধীন হচ্ছে।<br /><br />

<h3>Freeplay24 টিপস</h3>

<h4>freeplay24 ক্যাসিনো – বাকারাত কী?</h4>
বর্তমানে Baji-তে দুই প্রকারের বাকারাত রয়েছে তা হ’ল:<br />
১. ক্লাসিক বাকারাত<br />
২. ইন্সুসেন্স বাকারাত<br /><br />

ক্লাসিক বাকারাত খেলায়, মোট ৮টি ডেক (৪১৬ কার্ড) কার্ড ব্যবহার করা হয়। Ace বা টেক্কা অর্থাৎ A লিখা কার্ড এর মান ১ ধরা হয়, অন্যদিকে ১০ নম্বর কার্ড, জ্যাক বা গোলাম, কুইন অথবা কিং এই সব গুলোর মান ০ ধরা হয় এবং ১০ এর নিচে সবগুলো কার্ড এর মান ঐ সব কার্ডে লিখা নম্বরের মানের সমান ধরা হয়। যখন আপনার সব কয়টি কার্ড এর টোটাল ভেল্যু ডাবল- ডিজিট এর হয়ে যাবে তখন ফার্স্ট ডিজিটটিকে দিয়ে বাদ দিয়ে সেকেন্ড টিকে আপনার টোটাল ভেল্যু হিসেবে কাউন্ট করা হবে। এই খেলায় যে পক্ষের কার্ড এর টোটাল পয়েন্ট ৯ এর সবচেয়ে কাছাকাছি থাকবে সেই উইনার হবে।<br />

বাকারাত খেলায় সাধারণত দুটি পক্ষের মধ্যে ডিল করা হয়- একটি পক্ষ হ’ল ব্যাংকার এবং অন্যপক্ষ হ’ল প্লেয়ার। “প্লেয়ার”কে প্রথমে কার্ড দেওয়া হয়, প্লেয়ারকে প্রথম সেট কার্ড দেওয়ার পর প্লেয়ার অথবা ব্যাংকার এর মধ্যে যে কারো কার্ড এর টোটাল পয়েন্ট যদি ৮ অথবা ৯ এর সমান হয় তাহলে সেখানেই খেলা শেষ, কেউ কে-ই আর কোন কার্ড দেওয়া হয়না আর এটিকে-ই বলে ন্যাচারাল উইন। প্রথম সেট কার্ড দেওয়ার পর যদি কেউ উইন না হয় সে ক্ষেত্রে ‘থ্রী কার্ড রুলস’ অনুযায়ী আরেকটি কার্ড দেওয়া হতে পারে আবার নাও দেওয়া হতে পারে।<br />
বিগ / স্মল, ব্যাঙ্কার / প্লেয়ার পেয়ার, এ্যানি পেয়ার, পারফেক্ট পেয়ার, বোনাস প্লে এবং সুপার সিক্সের মতো অন্যান্য অপশনাল সাইড বেট রয়েছে।<br />

ইন্সুরেন্স বাকারাত মানে হল ইন্সুরেন্স পে টেবিল অনুসারে প্লেয়ার অথবা ব্যাংকার যেকোনো হ্যান্ড এর থার্ড কার্ড এ যাওয়ার আগে একজন খেলোয়ার কে ফিক্সড ওডডস এর বেট অফার করা। যখন খেলা শুরু হয় তখন একজন ইউজার ব্যাংকার অথবা প্লেয়ার উভয়ের জন্য বেট করতে পারে।<br /><br />
স্ট্যান্ডার্ড বেট টাইপ এবং পে আউট:<br />
ব্যাঙ্কার উইন, 1: 0.95 পে আউট<br />
প্লেয়ার উইন, 1: 1 পে আউট<br />
টাই উইন, 1: 8 পে আউট<br /><br />

<h3>Freeplay24 ক্যাসিনো – রুলেট কী?</h3>
রুলেট এর হুইলে টোটাল ৩৭ টি পকেট রয়েছে, প্রতিটি পকেটে ০-৩৬ পর্যন্ত ১টি করে ভিন্ন নম্বর দেওয়া থাকে। ৩৬টি পকেটে লাল এবং কালো রঙ করা থাকে এবং শুধুমাত্র ০ নম্বর লিখা পকেট এর রঙ হচ্ছে সবুজ। রুলেট গেমে, ডিলার সব সময় হুইলটিকে শুধুমাত্র এক দিকে ঘুরিয়ে দেয়। তারপর একটু কাত হয়ে থাকা বৃত্তাকার ট্র্যাকের চারপাশে একটি বল ঘুরানো হয়। যেটি হুইল এর বাইরের প্রান্ত ঘেসে ঘুরতে থাকে। এক সময় বলটি গতি হারাতে থাকে তখন পকেটের খাজে বাধাঁ পেয়ে পেয়ে স্লো হতে হতে এক সময় বলটি থেমে যায় এবং একটি পকেটের মধ্যে বসে যায়। ঐ পকেটের নম্বরটি উইনিং নম্বর এবং রঙ নির্ধারণ করে। একটি সঠিক গতি গঠনের জন্য বলটিকে হুইলটির ট্র্যাকের চারপাশে কমপক্ষে চার বার ঘূর্ণায়মান সম্পূর্ণ করতে হবে।<br />

<h3>Freeplay24 ক্যাসিনো – লাইটিং রুলেট কী?</h3>
লাইটিং রুলেট এ, স্ট্যান্ডার্ড ইউরোপিয়ান লাইভ রুলেট অনুসারে টোটাল ৩৭ পকেটে থাকে প্রতিটি পকেটে ০ থেকে ৩৬ পর্যন্ত আলাদা আলাদা একটি করে নম্বর দেওয়া থাকে, আপনি এই সবগুলো পকেট এ বেট ধরতে পারবেন। পকেট গুলোর মধ্যে ৩৬ টি তে লাল অথবা কালো রং করা থাকে এবং ০ নম্বর পকেটটির রং হচ্ছে সবুজ। নরমাল রুলেট এর সাথে এই লাইটিং রুলেট এর পার্থক্য তা আমরা এর নাম থেকে কিছুটা অনুমান করতে পারি, এই গেমটিতে রয়েছে ভিন্নধর্মী স্পিড এবং কিছু ইউনিক ফিচার যেমন লাকি নাম্বার অথবা লাকি পে আউট প্লেয়ারদের উইন হওয়ার একটা অতিরিক্ত চান্স অফার করে থাকে।
গেম এর প্রতিটি রাউন্ডে ১টি থেকে ৫টি পর্যন্ত লাকি নাম্বার থাকে, যদি আপনি এই নাম্বার গুলির যে কোনটিতে কোন স্ট্রেইট- আপ বেট জিতেন, তাহলে আপনার উইনিং মানি এর পরিমাণ ৫০ থেকে ৫০০ গুণ পর্যন্ত হয়ে যেতে পারে যা নির্ভর করে কত পরিমাণ জেনারেট হচ্ছে তার উপর। সকল লাকি নম্বর এবং কোন লাকি নম্বর কত পে আউট করা হবে তা স্বয়ংক্রিয়ভাবে রেন্ডমলি জেনারেট করা হয়। নন মাল্টিপ্লাইড স্টেইট-আপ বেট গুলোতে ৩০ঃ১ স্কেলে পে আউট করা হয় অর্থাৎ আপনি ২০ টাকা দিয়ে বেট উইন হলে ৬০০ টাকা পাবেন। এছাড়া অন্যান্য যেমন স্প্লিট্‌স , কর্নার্‌স এবং রেড/ব্ল্যাক এবং ডজন এই বেট গুলোতে স্ট্যান্ডার্ড রুলেট এর স্কেলে-ই পেমেন্ট করা হয়। একই সাথে এখানে স্ট্যান্ডার্ড রুলেট এর মত একটি স্পেশাল এলিপটিক্যাল রুলেট টেবিল রয়েছে যেখানে পাশের বেট গুলোতে আপনি আরো সহজে বেট ধরতে পারবেন।<br />
তা ছাড়া, ইভোলিউশন গেমিংয়ের অনেকগুলি স্পেশাল ফিচার রয়েছে। উদাহরণস্বরূপ, ‘মাল্টি-গেম টেবিল’ আপনাকে একসাথে ৪ টি ভিন্ন ভিন্ন গেম টেবিলে যোগদান করতে অনুমতি দেয় এবং সেগুলি একই ব্রাউজার উইন্ডোতে প্রদর্শন করে, এমন কিছু যা আপনি মিস করতে চান না!<br /><br />

<h3>ফ্যান্সি বেট কি?</h3>
ফ্যান্সি বেট হলো এমন একটি বেট মার্কেট যা ক্রিকেট পান্টারদের/বাজিকরদের জন্য কাস্টমাইজ করা হয়েছে এবং যা শুধু ক্রিকেট ম্যাচে করা যায়। ফেন্সি ব্যাটিংয়ের জন্য নিজস্ব নিদিষ্ট রুলস রয়েছে। তাছাড়া ফ্যান্সি বেটে বেটিং করলে তা এক্সচেঞ্জের লিকুইডিটি তে কোন প্রভাব ফেলে না। <br />
আপনারা কি ফ্যান্সি ব্যাটিংয়ের ইয়েস এবং নো এ দুইটি শর্ত নিয়ে চিন্তিত? ফ্যান্সি বেট হলো সব সময় ব্যাক বেটের মত। আপনি ইয়েস এ বেট করলে বুঝায় আপনি ধরে নিচ্ছেন এই ঘটনাটি ঘটবে এবং নো তে বেট করলে বুঝায় আপনি ধরে নিচ্ছেন এই ঘটনাটি ঘটবে না।<br /><br />

<h3>প্রিমিয়াম বেট কি?</h3>
প্রিমিয়াম বেট হল স্পোর্টস বুক মার্কেট আর সেটি সব খেলার জন্যই এভেইল্যাবল এবং এটি এক্সচেঞ্জের লিক্যুইডিটিকে প্রভাবিত করবে না। ইন-প্লে কিংবা চলমান ম্যাচগুলোতে এবং প্রি-ম্যাচ মার্কেট অর্থাৎ ম্যাচ শুরুর আগেও প্রিমিয়াম বেট করা যায়। ইন-প্লে বেটে একটি রানিং ম্যাচের মধ্যে বেটিং করা যায় এবং প্রি-ম্যাচ মার্কেটে ম্যাচ শুরুর আগে বেট ধরতে হয়। <br />
একটা দল যখন ব্যাটিং করে ক্রিকেটে তখন সেটাকে ইনিংস বলে। যখন ঐ দলটির সব ব্যাটসম্যান আউট হয়ে যায় অথবা বোলিং এর সব ওভার শেষ হয়ে যায় তখন ঐ ইনিংসটি শেষ হয়। যদি আপনি ওভার ১৫৯.৫ এ বেটিং করেন তার মানে হল আপনি বিশ্বাস এবং সমর্থন করছেন যে চেন্নাই সুপার কিংস SRL দলটির টোটাল রান ১৫৯ বা তার চেয়ে বেশি হবে প্রথম ইনিংসে। আন্ডার ১৫৮ এর জন্য এর বিপরীত ঘটনাটি ঘটবে। <br /><br />

<h3>এই যে না</h3>
স্পোর্টসবুক কোন ধরনের স্পোর্টস ইভেন্ট প্রদান করে?<br />
বেশিরভাগ স্পোর্টসবুক প্রধান স্পোর্টস ইভেন্ট, বিশেষ করে কলেজ এবং পেশাদার ইভেন্টগুলিতে বেট গ্রহণ করে। কিছু অনলাইন বুকমেকার নন- স্পোর্টিং ইভেন্টগুলিতে পলিটিক্যাল ইলেকশন এবং/অথবা অস্কারের মতো যে ধরনের বেটের অফার দেয় তা সম্প্রসারিত করে। সর্বাধিক জনপ্রিয় স্পোর্টস বেট অন্তর্ভুক্ত করা হল: <br />

✓ ফুটবল <br />
✓ ভার্চুয়াল স্পোর্টস<br />
✓ ফিন্যান্স<br />
✓ ই-স্পোর্টস<br />
✓ বাস্কেটবল<br />
✓ বেসবল<br />
✓ ফুটবল<br />
✓ টেনিস<br />
✓ ব্যাডমিন্টন	<br />	
✓ ভলিবল<br />
✓ স্নুকার/পুল<br />
✓ মোটর স্পোর্টস<br />
✓ ক্রিকেট<br />
✓ রাগবি<br />
✓ ডার্ট<br />
✓ টেবিল টেনিস<br />
✓ ফিল্ড হকি<br />
✓ হ্যান্ডবল		<br />
✓ অলিম্পিক<br />
✓ অ্যাথলেটিক্স<br />
✓ সাঁতার<br />
✓ ওয়াটার পোলো<br />
✓ আরচারি<br />
✓ পেনঞ্চিং<br />
✓ জুডো<br />
✓ তায়কোয়ান্দো<br />
✓ ট্রায়াথলন<br /><br />

<h3>বেটিং এক্সচেঞ্জে “ব্যাক” এবং “লে” বেটিং বলতে কী বোঝায়?</h3>

“ব্যাক” এবং অডস বেট সবসময় নীল রঙে চিহ্নিত করা হয় এবং ‘লে’ বেট সবসময় গোলাপী রঙে চিহ্নিতকরা হয়। “ব্যাক” এ বেটিং করা মানে হচ্ছে কোন একটি ঘটনা ঘটার স্বপক্ষে বেট করা যেখানে লে বেটিএ আপনি নিজেই একজন বুকমেকারের রুল প্লে করবেন। “লে” বেট এর ক্ষেত্রে আপনি সবসময়ই আপনার বিপক্ষের বেট থেকে আপনার স্টেক এর সমপরিমাণ টাকা জিতবেন আর এই “লে” তে বেটিং হচ্ছে কোন টনা ঘটার বিপক্ষে বেট করা।<br />
লে এর বেটিং প্রসেসটা বুঝার জন্য আর একটি গুরুত্বপূর্ণ জিনিস আপনাকে বুঝতে হবে আর সেটি হল লাইবিলিটি। আপনি নিজেকে একজন বুকমেকার মনে করুন। আপনি যদি আপনার বেট হারেন বুক মেকার আপনার স্টেকটি রেখে দেয়। আপনার বেট জিতলেও বুকমেকার এর আপনাকে উইনিং মানি টা দিতে হয়। এই উইনিং মানি এর পরিমাণ আপনার স্টেক এর পরিমাণ এর চেয়ে অনেক বেশী ও হতে পারে। এই ব্যাপারটি হলো লে তে বেট করা। যদি এই সিলেকশনটি জিতে, তবে আপনাকে উইনিং মানি পে করতে হবে। এই সম্ভাব্য পে আউট এর পরিমাণ হলো লাইবিলিটি। অর্থাৎ আপনার লে বেটটি হারলে যথাযথভাবে কত টাকা আপনাকে পেমেন্ট করতে হবে এই লাইবিলিটি হলো সেই টাকার পরিমান। <br /><br />

<h3>একটি লে বেট রাখা </h3>


একটি মার্কেট নির্বাচন করুন, আপনি নির্বাচন করতে চান এমন একটি লে সিলেক্ট করুন এবং best lay price/odds ক্লিক করুন।<br />
উদাহরণস্বরূপ, কোন একটি টিম এ 2.42 অডস এ আপনি ১০০ টাকা বেট করেছেন। ওই বেটের ব্যাক এ কেউ ১০০ টাকা স্টেক ধরেছে। তার মানে এই বেটে আপনার লাইবিলিটি হল ১৪২ টাকা। আপনি যদি হেরে যান আপনার ব্যালেন্স থেকে আপনার লাইবিলিটি ১৪২ টাকা কেটে নেওয়া হবে।<br />
আপনার সম্ভাব্য লাভ: ৳ ১০০<br />
আপনার সম্ভাব্য ক্ষতি: ৳ ১৪২<br /><br />

<h3>স্পোর্টসবুক – 1X2 কি?</h3>
“1X2” 3 টি ফলাফলকে নির্দেশ করে যা একটি ইভেন্টের একটি নির্ধারিত সময়ের মধ্যে হতে পারে।<br />
হোম টিম জিতবে, অ্যাওয়ে টিম জিতবে, অথবা ইভেন্টটি ড্র (X) এ শেষ হবে।<br /><br />

<h3>আমি কি আমার বেটটি পরিবর্তন বা বাতিল করতে পারি?</h3>
দুর্ভাগ্যক্রমে, একবার আপনি বেট কনফার্ম করলে, এটি বাতিল বা এডিট করা করা সম্ভব নয়। কনফার্ম করার আগে আপনার বেটের বিস্তারিত সঠিক কিনা তা নিশ্চিত হয়ে নিন। <br />
ভুলভাবে বেট ধরলে কি আমি রিফান্ড/ফেরত পেতে পারি?<br />
দুর্ভাগ্যক্রমে, একবার আপনি বেট কনফার্ম করলে, এটি বাতিল / এডিট করা বা রিফান্ডের জন্য অনুরোধ করা সম্ভব নয়। কনফার্ম করার আগে আপনার বেটের বিস্তারিত সঠিক কিনা তা নিশ্চিত হয়ে নিন। <br /><br />




যদিও আমাদের প্ল্যাটফর্মে রাখা বেশিরভাগ বেটই টার্নওভার ক্যালকুলেশনের ক্ষেত্রে গণনা করা হয়, এবং আমরা যে বোনাসগুলি অফার করি তা অনেক গেমেই ব্যবহার করা যায়, তবে কিছু কিছু ক্ষেত্রে একটু ব্যতিক্রম রয়েছে। বোনাস ওয়েজারিং এবং টার্নওভার ক্যালকুলেশন এর ক্ষেত্রে যে গেমগুলো বাদ দেওয়া হয় সে গেমগুলি সম্পর্কে বিস্তারিত তথ্যের জন্য, অনুগ্রহ করে নীচের টেবিলটি দেখুন: <br /><br />
<img class="img-fluid" src="https://speedcdn.io/assets/king-v8/landing02/picture4.png" alt=""><br /><br />

ওয়েজরিং রিকয়ারমেন্ট টার্নওভার রিকয়ারমেন্ট হিসাবেও পরিচিত। ওয়েজরিং রিকয়ারমেন্ট হ’ল একটি গুণক যা কোনও একটি ডিপোজিট বা বোনাস নেওয়ার পর টাকা উথড্র করার জন্য আপনার টাকাটি সর্বমোট কতবার খেলতে হবে সেই নাম্বারটি নির্দেশ করে।<br /><br />

নোট:১. ভিন্ন ভিন্ন প্রমোশনের ক্ষেত্রে ওয়েজরিং রিকয়ারমেন্ট সংক্রান্ত এবং সীমাবদ্ধতাগুলো ভিন্ন ভিন্ন হয়, আমরা আপনাকে কোন প্রমোশনে অংশ নেওয়ার আগে উক্ত প্রমোশনের শর্তাদি এবং শর্তাবলী সম্পর্কে স্পষ্ট করে জানার জন্য পরামর্শ দিই। ২. একবার প্রমোশনে অংশগ্রহণ করার পরে প্রমোশনে বাতিল করা যাবে না।

</div>